import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import TileCard from './TileCard';
import { GripVertical } from 'lucide-react';

function DraggableTileCard({ tile, onTileClick, onEditTile, isArrangeMode }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ 
    id: tile._id,
    disabled: !isArrangeMode 
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    position: 'relative',
  };

  return (
    <div ref={setNodeRef} style={style} className="relative">
      {isArrangeMode && (
        <div 
          {...attributes} 
          {...listeners}
          className="absolute top-2 right-2 z-20 p-2 bg-purple-600 rounded-lg cursor-move hover:bg-purple-700 transition-colors"
        >
          <GripVertical className="w-5 h-5 text-white" />
        </div>
      )}
      <div className={isArrangeMode ? 'pointer-events-none' : ''}>
        <TileCard 
          tile={tile} 
          onTileClick={onTileClick} 
          onEditTile={onEditTile}
        />
      </div>
    </div>
  );
}

export default DraggableTileCard;